import { Deposit, ValueType } from '@urbanx/agx.campaigns.client';
import { ErrorState } from 'types/Payable';

export interface ContractDepositErrorState {
  initial: ErrorState;
  balance: ErrorState;
}

export interface ContractDepositModel {
  initialDeposit: Deposit;
  balanceDeposit: Deposit;
}

export const DepositOptions = [
  { label: ValueType.Dollar, value: ValueType.Dollar },
  { label: ValueType.Percentage, value: ValueType.Percentage },
];

export enum DepositRadioOptionType {
  TenPercentage = '10',
  FivePercentage = '5',
}
